// Months data - both Gregorian and Hijri with translations
export var gregorianMonths = {
  en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  ar: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
};
export var hijriMonths = {
  en: ['Muharram', 'Safar', 'Rabi al-Awwal', 'Rabi al-Thani', 'Jumada al-Awwal', 'Jumada al-Thani', 'Rajab', 'Sha\'ban', 'Ramadan', 'Shawwal', 'Dhu al-Qadah', 'Dhu al-Hijjah'],
  ar: ['محرم', 'صفر', 'ربيع الأول', 'ربيع الآخر', 'جمادى الأولى', 'جمادى الآخرة', 'رجب', 'شعبان', 'رمضان', 'شوال', 'ذو القعدة', 'ذو الحجة']
};

// Labels translations
export var labels = {
  day: {
    en: 'Day',
    ar: 'اليوم'
  },
  selectDay: {
    en: 'Select Day',
    ar: 'اختر اليوم'
  },
  month: {
    en: 'Month',
    ar: 'الشهر'
  },
  selectMonth: {
    en: 'Select Month',
    ar: 'اختر الشهر'
  },
  year: {
    en: 'Year',
    ar: 'السنة'
  },
  selectYear: {
    en: 'Select Year',
    ar: 'اختر السنه'
  },
  gregorian: {
    en: 'Gregorian',
    ar: 'ميلادي'
  },
  hijri: {
    en: 'Hijri',
    ar: 'هجري'
  },
  error: {
    en: 'Invalid date. Please select a valid date.',
    ar: 'تاريخ غير صالح. يرجى اختيار تاريخ صالح.'
  }
};